
import LocalizedStrings from 'react-localization';
import en from './en';
import es from './es';
import pt from './ptBR';

import 'moment/locale/es';

const strings = new LocalizedStrings({
  en,
  es,
  pt,
});

const availableLangs = ['en', 'es', 'pt'];

let lang = localStorage.getItem('lang');

function normalizeLang(inputLang) {
  const langLower = inputLang?.toLowerCase() || '';
  if (langLower.startsWith('es')) return 'es';
  if (langLower.startsWith('pt')) return 'pt';
  return 'en';
}


lang = normalizeLang(lang || navigator.language);

if (!availableLangs.includes(lang)) {
  lang = 'en';
}
strings.setLanguage(lang);

export default strings;
